import * as React from "react";
import { Input as InputPrimitive } from "@base-ui/react/input";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <InputPrimitive
      type={type}
      data-slot="input"
      className={cn(
        "h-8 w-full min-w-0 rounded-sm border border-line-2 bg-background px-2.5 text-[13px] text-foreground transition-[border-color] duration-[120ms] outline-none file:inline-flex file:h-6 file:border-0 file:bg-transparent file:text-[13px] file:font-medium file:text-foreground placeholder:text-fg-3 focus-visible:border-focus focus-visible:outline-2 focus-visible:-outline-offset-1 focus-visible:outline-focus disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-55 aria-invalid:border-danger",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
